import React, { FC } from 'react';
import { AppRoute } from '@web/core/navigation/app.navigator';
import { MainPage } from './main-page';
import { Navigate, Route, Routes } from 'react-router-dom';
import { StisPublications } from '@web/vin-sessions/components/stis-publications/stis-publications';
import { PrivacyPolicy } from './privacy-policy';
import { TermsAndConditionsAndPrivacy } from './terms-conditions';
import { FAQ } from './faq';
import { ContactUs } from './contact-us';
import { EmergencyGuides } from './emergency-guides';
import { SiteLinkLayout } from './site-link-layout';
import { LandingPageLayout } from './landing-page-layout';
import { SpecialTools } from './special-tools';

interface MainContentProps {}

export const routes: AppRoute[] = [
    {
        path: '/',
        main: () => (
            <LandingPageLayout>
                <MainPage />
            </LandingPageLayout>
        ),
    },
    {
        path: '/stis',
        main: () => (
            <LandingPageLayout>
                <StisPublications />
            </LandingPageLayout>
        ),
    },
    {
        path: '/public/privacy-policy',
        private: false,
        main: () => (
            <SiteLinkLayout>
                <PrivacyPolicy />
            </SiteLinkLayout>
        ),
    },
    {
        path: '/public/terms-conditions',
        private: false,
        main: () => (
            <SiteLinkLayout>
                <TermsAndConditionsAndPrivacy />
            </SiteLinkLayout>
        ),
    },
    {
        path: '/public/faq',
        private: false,
        main: () => (
            <SiteLinkLayout>
                <FAQ />
            </SiteLinkLayout>
        ),
    },
    {
        path: '/public/contact_us',
        private: false,
        main: () => (
            <SiteLinkLayout>
                <ContactUs />
            </SiteLinkLayout>
        ),
    },
    {
        path: '/public/emergency-guides',
        private: false,
        main: () => (
            <LandingPageLayout>
                <EmergencyGuides />
            </LandingPageLayout>
        ),
    },
    {
        path: '/public/diagnostic-tool-info',
        private: false,
        main: () => (
            <SiteLinkLayout>
                <SpecialTools />
            </SiteLinkLayout>
        ),
    },
];

export const MainContent: FC<MainContentProps> = (props) => {
    return (
        <Routes>
            {routes.map((route, index) => {
                if (route.redirectTo) {
                    return <Route key={index} path={route.path} element={<Navigate to={route.redirectTo} />} />;
                }

                if (route.main) {
                    return <Route key={index} path={route.path} element={<route.main />} />;
                }

                return null;
            })}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
